import React from 'react';
import styled from 'styled-components';

import { TONE_AXES } from '../copy';
import { RuntimeContextToneOfVoice } from '../types';
import { Row } from './Row';

interface ToneOfVoiceSlidersProps {
  tone: RuntimeContextToneOfVoice;
  // Fires when any axis row is clicked. Each axis links to the same Brand
  // Center tone section, so a single callback is sufficient.
  onAxisClick?: () => void;
}

const Dots = styled.div`
  display: flex;
  gap: 3px;
`;

const Dot = styled.span<{ $filled: boolean }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${({ $filled }) =>
    $filled ? 'var(--link-color)' : 'var(--gray-3)'};
`;

// Five dots mirroring the five slider stops in the Brand Guidelines Tone of
// Voice section, with the dot at the configured 1–5 value filled. Values
// outside the schema range are clamped so a bad payload can't blank the row.
const clampToScale = (value: number): number =>
  Math.min(5, Math.max(1, Math.round(value)));

const POSITIONS: ReadonlyArray<number> = [1, 2, 3, 4, 5];

export const ToneOfVoiceSliders: React.FC<ToneOfVoiceSlidersProps> = ({
  tone,
  onAxisClick,
}) => (
  <>
    {TONE_AXES.map((axis) => {
      const value = tone[axis.key];
      if (value == null) return null;
      const position = clampToScale(value);
      const label = `${axis.left} ↔ ${axis.right}`;
      return (
        <Row key={axis.key} label={label} onNavigate={onAxisClick}>
          <Dots aria-label={`${axis.left} to ${axis.right}: ${value} of 5`}>
            {POSITIONS.map((p) => (
              <Dot key={p} $filled={p === position} />
            ))}
          </Dots>
        </Row>
      );
    })}
  </>
);
